import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { isTabType } from "@util/helpers";

/**union of types a tab can accept */
export type TabType =
  | "eligibilityTab"
  | "nominationsTab"
  | "businessman-of-the-year"
  | "outstanding-chief-executive-of-the-year"
  | "the-enterprise-award"
  | "outstanding-overseas-executive-of-the-year"
  | "young-business-leader-of-the-year"
  | "assessmentTab"
  | "declarationsTab"
  | "selectionsTab"
  | "best-managed-board"
  | "best-chief-executive-officer"
  | "best-chief-financial-officer"
  | "best-risk-management"
  | "best-investors-relations"
  | "best-annual-report"
  | "special-recognition-award"
  | "distinguished-distribution"
  | "special-edition"
  | "applicationsTab"
  | "rulesTab"
  | "applyTab"
  | "termsConditionsTab"
  | "submissionsTab";

export interface TabItem {
  /** unique identifies for the tab item used to display tabs */
  key: TabType;
  /** label for the tab item used to display tabs */
  label: string;
}

/**
 * Custom hook to handle tabs states
 */
const useTabs = (tabs: TabItem[]) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(tabs[0]?.key || "");

  const hashValue = location.hash;

  const tabKey = hashValue.replace("#", "");

  useEffect(() => {
    if (!isTabType(tabKey, tabs)) return;

    setActiveTab(tabKey);
  }, [tabKey, tabs]);

  const activeLabel = tabs.find((tab) => tab.key === activeTab)?.label || "";

  const changeTab = (key: TabType) => {
    setActiveTab(key);
  };

  return {
    activeTab,
    activeLabel,
    changeTab,
  };
};

export default useTabs;
